export const WebsocketNotifications = {
  messageReceived: 'message-received',
  commandCompleted: 'command-completed',
  errorReceived: 'error-received',
  caseOpened: 'case-opened',
  caseClosed: 'case-closed',
  openedCases: 'opened-cases',
  appUpdated: 'app-updated',
  incidentMessage: 'incident-message'
};
